import * as types from "../../actions/actionTypes";
const initialState = {
  loading: true,
  removeLoading: false,
  inProcess: false,
  data: { data: [], links: {}, message: [], meta: {} },
  selected: {},
  error: false,
  imagesLoading: true,
  imagesError: false,
  images: []
};

const ManagerPayment = (state = initialState, action) => {
  switch (action.type) {
    case types.MANAGER_REMOVE_PAYMENT_REQUEST:
      return { ...state, removeLoading: true, loading: true };
    case types.MANAGER_REMOVE_PAYMENT_SUCCESS:
      return {
        ...state,
        ...action.payLoad,
        removeLoading: false,
        loading: false
      };
    case types.MANAGER_REMOVE_PAYMENT_FAILURE:
      return {
        ...state,
        ...action.payLoad,
        removeLoading: false,
        loading: false
      };

    case types.MANAGER_GET_IMAGE_PAYMENT_REQUEST:
      return { ...state, imagesLoading: true, imagesError: false };
    case types.MANAGER_GET_IMAGE_PAYMENT_SUCCESS:
      return { ...state, images: action.payLoad, imagesLoading: false };
    case types.MANAGER_GET_IMAGE_PAYMENT_FAILURE:
      return { ...state, imagesLoading: false, imagesError: true };

    case types.MANAGER_STORE_PAYMENT_REQUEST:
      return { ...state, inProcess: true };
    case types.MANAGER_STORE_PAYMENT_SUCCESS:
      return { ...state, inProcess: false };
    case types.MANAGER_STORE_PAYMENT_FAILURE:
      return { ...state, inProcess: false };
    case types.MANAGER_UPDATE_PAYMENT_REQUEST:
      return { ...state, inProcess: true };
    case types.MANAGER_UPDATE_PAYMENT_SUCCESS:
      return { ...state, inProcess: false };
    case types.MANAGER_UPDATE_PAYMENT_FAILURE:
      return { ...state, inProcess: false };
    case types.MANAGER_GET_PAYMENT_REQUEST:
      return { ...state, loading: true };
    case types.MANAGER_GET_PAYMENT_SUCCESS:
      return { ...state, selected: action.payLoad, loading: false };
    case types.MANAGER_GET_PAYMENT_FAILURE:
      return { ...state, loading: false, error: true };
    default:
      return state;
  }
};

export default ManagerPayment;
